import { default as UniversalLink } from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { default as Component } from '@plone/volto/components/theme/Component/Component';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark as faSolidBookmark } from '@fortawesome/free-solid-svg-icons';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';

export const LocationGridListingItemTemplate = (props) => {
  const { item } = props;
  const locations = useSelector((state) => state.locations.get?.data ?? []);
  return (
    <div className="item-location">
      <div className="item-image-container">
        {item.image_field !== '' && (
          <Component
            componentName="PreviewImage"
            item={item}
            alt={item.title}
            className="item-image"
            sizes="(min-width: 1400px) 550px, 90vw"
          />
        )}
      </div>
      <div className="item-title">
        <h4>
          <UniversalLink item={item}>{item.title}</UniversalLink>
        </h4>
        {locations.find((l) => l.location['UID'] === item['UID'])?.status ? (
          <FontAwesomeIcon
            icon={faSolidBookmark}
            className={`icon status-${locations.find((l) => l.location['UID'] === item['UID'])?.status}`}
          />
        ) : (
          <FontAwesomeIcon icon={faBookmark} className={`icon status-0`} />
        )}
      </div>
    </div>
  );
};
